module.exports = __webpack_public_path__ + "static/media/icon-success-green.1a9fb475.svg";